export const addClass = (node: HTMLElement, classes: string | string[]): void => {
  if (Array.isArray(classes)) {
    return node.classList.add(...classes);
  }

  return node.classList.add(classes);
};

export const clear = (node: Node): void => {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
};

export const transitionEnd = (
  element: HTMLElement,
  callback: CallableFunction,
  options: Object = {},
): void => {
  const hasDuration = parseFloat(getComputedStyle(element).getPropertyValue('transition-duration') || '0') !== 0;

  if (hasDuration) {
    element.addEventListener('transitionend', (event) => {
      callback(event);
    }, options);
  } else {
    callback();
  }
};

export const repaint = (node: HTMLElement): void => {
  // eslint-disable-next-line no-void
  void (node.offsetHeight);
};

export const stringToNode = (string: String): HTMLElement => {
  const template = document.createElement('template');
  template.innerHTML = string.trim();

  if (!(template.content.firstChild instanceof HTMLElement)) {
    throw new TypeError('The passed string was invalid. The first content must be a HTML tag');
  }

  return template.content.firstChild;
};

export default {
  addClass,
  clear,
  transitionEnd,
  repaint,
  stringToNode,
};
